export default __webpack_public_path__ + "static/media/search-icon.dd4c17a4.svg";